import React, { useState } from "react"
import { Logo } from "../Logo"
import { Box, Button, Link, useScreenSizeMatch, Icon } from "@ncs/web-legos"

import { ContentWrapperEcomm } from "../ContentWrapperEcomm"
import { ShopBarCartSummaryEcomm } from "./ShopBarCartSummaryEcomm"
import { ShopBarNavEcomm } from "./ShopBarNavEcomm"
import { ShopBarSearch } from "./ShopBarSearch"
import { ShopBarUserWelcomeEcomm } from "./ShopBarUserWelcomeEcomm"
import { MobileNavModalEcomm } from "../MobileNavModalEcomm"
import {
	logoLinkStyle,
	mobileNavButtonStyle,
	shopBarSearchStyle,
	shopBarContainerStyle,
	outerContainerStyle,
} from "./styles"

export const ShopBarEcomm: React.FC = () => {
	const [showNavModal, setShowNavModal] = useState(false)
	const screenIsMediumUp = useScreenSizeMatch("md", "up")

	return (
		<>
			<div css={outerContainerStyle}>
				<ContentWrapperEcomm>
					<Box
						display="flex"
						columnGap="1rem"
						alignItems="center"
						justifyContent="space-between"
					>
						<div>
							{!screenIsMediumUp && (
								<Button
									onClick={() => setShowNavModal(true)}
									aria-label="Open navigation menu"
									title="Open navigation menu"
									css={mobileNavButtonStyle}
								>
									<Icon icon="bars" color="white" fontSize={1.7} />
								</Button>
							)}
							<Link to="/" css={screenIsMediumUp && logoLinkStyle}>
								{!screenIsMediumUp ?
									<Logo height={1.5} company="ncsWhite" />
								:	<Logo
										height={1.875}
										maxWidth={!screenIsMediumUp ? "7rem" : undefined}
										company="ncsWhite"
									/>
								}
							</Link>
						</div>
						{!screenIsMediumUp && (
							<>
								<ShopBarCartSummaryEcomm />
								<ShopBarUserWelcomeEcomm />
							</>
						)}

						{screenIsMediumUp && (
							<>
								<ShopBarSearch css={shopBarSearchStyle} />
								<ShopBarUserWelcomeEcomm />
							</>
						)}
					</Box>
					{!screenIsMediumUp && <ShopBarSearch css={shopBarSearchStyle} />}
				</ContentWrapperEcomm>
			</div>
			{screenIsMediumUp && (
				<div css={shopBarContainerStyle}>
					<ContentWrapperEcomm>
						<Box display="flex" alignItems="center">
							<ShopBarNavEcomm />
							<ShopBarCartSummaryEcomm />
						</Box>
					</ContentWrapperEcomm>
				</div>
			)}
			<MobileNavModalEcomm isOpen={showNavModal} onClose={() => setShowNavModal(false)} />
		</>
	)
}
